export const INITIALIZE_USER = 'INITIALIZE_USER';
export const SET_LOGIN_USER_DATA = 'SET_LOGIN_USER_DATA';
export const SET_CONFIG_DATA = 'SET_CONFIG_DATA';

export const SET_COMPANIES_DATA = 'SET_COMPANIES_DATA';
export const SET_GROUP_DATA = 'SET_GROUP_DATA';
export const SET_CATEGORIES_DATA = 'SET_CATEGORIES_DATA';
export const SET_JOBS_DATA = 'SET_JOBS_DATA';
export const SET_TEAMS_DATA = 'SET_TEAMS_DATA';
export const SET_POSITIONS_DATA = 'SET_POSITIONS_DATA';
export const SET_SERVICES_DATA = 'SET_SERVICES_DATA';
export const SET_MEMBERS_DATA = 'SET_MEMBERS_DATA';
export const SET_MEMBERS_WITH_AUTHORITY_DATA = 'SET_MEMBERS_WITH_AUTHORITY_DATA';
export const SET_LOG_OF_MEMBER_WITH_AUTHORITY_DATA = 'SET_LOG_OF_MEMBER_WITH_AUTHORITY_DATA';
export const SET_SELECTED_MEMBER_DATA = 'SET_SELECTED_MEMBER_DATA';

export const ADD_MEMBERS_DATA = 'ADD_MEMBERS_DATA';
export const EDIT_MEMBERS_DATA = 'EDIT_MEMBERS_DATA';

export const CREATE_JOBS_DATA = 'CREATE_JOBS_DATA';
export const EDIT_JOBS_DATA = 'EDIT_JOBS_DATA';
export const REMOVE_JOBS_DATA = 'REMOVE_JOBS_DATA';

export const CREATE_TEAMS_DATA = 'CREATE_TEAMS_DATA';
export const EDIT_TEAMS_DATA = 'EDIT_TEAMS_DATA';
export const REMOVE_TEAMS_DATA = 'REMOVE_TEAMS_DATA';

// loading
export const SET_LOADING = 'SET_LOADING';
// 사용자 알림
export const SET_MESSAGE = 'SET_MESSAGE';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js